/* eslint-disable */
const getters = {
  getProduct(state) {
    return {
      ...state.data,
      photoable_type: 'App\\Product',
    };
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
